import { axiosHelperWhats } from "../../helpers/test/axiosHelperWhats";

export const useBot = () => {
  const getNotificacionesBot = async (idNegocio, total_notificaciones) => {
    let resp = "";
    if (idNegocio) {
      resp = await axiosHelperWhats({ url: "respuestas/bot/"+idNegocio+`${total_notificaciones ? "?total_notificaciones="+total_notificaciones: ""}` });
    }
    
    return resp;
  };
  const notificacionHistorico = async (idNegocio) => {
    let resp = await axiosHelperWhats({ url: "respuestas/bot-historico/"+idNegocio });
    return resp;
  };

  const putNotificacionesBot = async (id_respuesta, approbe) => {
    let resp = await axiosHelperWhats({
      url: "respuestas/approbe-request",
      data: {
        id_respuesta,
        approbe,
      },
      method: "put",
    });
    
    return resp;
  };

  const descargarNotificaciones = async (fechas, idNegocio) => {
    let resp = await axiosHelperWhats({
      url: "respuestas/download-bot/"+idNegocio,
      data: fechas,
      method: "post",
    });
    return resp;
  };

  return {
    getNotificacionesBot,
    putNotificacionesBot,
    notificacionHistorico,
    descargarNotificaciones,
  };
};
